<template>
  <main class="main-container">
    <div class="k-onboarding__quest-wrapper">
      <div class="k-onboarding__quest">
        <div class="k-onboarding__title" v-if="!editProfile">Добро пожаловать!</div>
        <div
          class="k-onboarding__subtitle"
          v-if="!editProfile"
        >Для завершения регистрации, ответьте на несколько вопросов</div>

        <div class="k-onboarding__quest-task">Сначала укажите свой пол:</div>
        <div
          :class="['k-onboarding-button k-gender-button', {'ob-orange': gender === 'female', 'ob-white': gender !== 'female'}]"
          @click="gender = 'female'"
        >Женский</div>
        <div
          :class="['k-onboarding-button k-gender-button', {'ob-orange': gender === 'male', 'ob-white': gender !== 'male'}]"
          @click="gender = 'male'"
        >Мужской</div>
        <a
          @click.prevent="processSubmit"
          href="#"
          :class="['k-onboarding__quest-next', { active: !!gender }]"
        >Далее</a>
        <slot />
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "OnboardingGender",
  props: {
    editProfile: Object,
  },
  computed: {
    ...mapGetters([
      "getProfileGender",
      'getCurrentProfile',
    ]),
    currentCreatedProfile() {
      return this.$store.getters.getUserFamily.find(el => el.is_main === 't')
    },
    currentProfile() {
      return this.getCurrentProfile || {}
    },
    gender: {
      get() {
        if (this.editProfile) return this.editProfile.gender;
        return this.getProfileGender;
      },
      set(value) {
        this.setGender(value);
      }
    },
  },
  methods: {
    ...mapActions([
      'updateProfile',
      'createProfile',
    ]),
    setGender(gender) {
       if (!this.editProfile) {
        this.$store.dispatch("setProfileData", { gender });
      } else {
        this.editProfile.gender = gender;
      }
    },
    async processSubmit() {
      if (this.gender) {
        if (this.currentCreatedProfile && !this.editProfile) {
          await this.updateProfile({
            id: this.currentCreatedProfile.id,
            gender: this.gender,
          });
        }
        this.$router.push({ name: "OnboardingBirthday" });
      }
    },
    async createEmptyProfile() {
      await this.createProfile(true);
      this.$router.push("/");
    }
  }
};
</script>

<style scoped>

</style>
